<template>
  <Dialog :open="open" @close="$emit('close')">
    <template v-slot:title>
      <FlexRow full-width justify="center">
        <Label size="h6" bold text="検索条件を保存" />
      </FlexRow>
    </template>
    <template v-slot:default>
      <FlexRow justify="center">
        <FlexColumn width="640px">
          <Label text="検索条件" bold />
          <FlexColumn>
            <FlexRow v-if="andKeyword">
              <Label bold text="キーワード（すべてを含む） :"/>
              <Label bold :text="andKeyword" />
            </FlexRow>
            <FlexRow v-if="orKeyword">
              <Label bold text="キーワード（いずれかを含む） :"/>
              <Label bold :text="orKeyword" />
            </FlexRow>
            <FlexRow v-if="data && data.length > 0">
              <Label bold text="経験のあるデータ :"/>
              <Label bold :text="dataLabel" />
            </FlexRow>
            <FlexRow v-if="currentPrefectures && currentPrefectures.length > 0">
              <Label bold text="現在の居住地 :"/>
              <Label bold :text="currentPrefecturesLabel" />
            </FlexRow>
            <FlexRow v-if="prefectures && prefectures.length > 0">
              <Label bold text="希望勤務地 :"/>
              <Label bold :text="prefecturesLabel" />
            </FlexRow>
            <FlexRow v-if="positions && positions.length > 0">
              <Label bold text="経験のある職種 :"/>
              <Label bold :text="positionsLabel" />
            </FlexRow>
            <FlexRow v-if="salaryLower || salaryUpper">
              <Label bold text="年収 :"/>
              <Label v-if="salaryLower" bold :text="`${salaryLower}万以上`" />
              <Label v-if="salaryUpper" bold :text="`${salaryUpper}万以下`" />
            </FlexRow>
            <FlexRow v-if="gender != null">
              <Label bold text="性別 :"/>
              <Label bold :text="genderLabel" />
            </FlexRow>
            <FlexRow v-if="ageLower || ageUpper">
              <Label bold text="年齢 :"/>
              <Label v-if="ageLower" bold :text="`${ageLower}歳以上`" />
              <Label v-if="ageUpper" bold :text="`${ageUpper}歳以下`" />
            </FlexRow>
            <FlexRow v-if="medalist">
              <Label bold text="コンペ成績 :"/>
              <Label bold text="コンペ上位者" />
            </FlexRow>
            <FlexRow v-if="newcomer">
              <Label bold text="新規登録者のみ"/>
            </FlexRow>
            <FlexRow v-if="scoutable">
              <Label bold text="スカウト送付可能のみ"/>
            </FlexRow>
          </FlexColumn>
          <TextField v-model="name" name="検索条件名" />
        </FlexColumn>
      </FlexRow>
    </template>
    <template v-slot:actions>
      <FlexRow full-width justify="center">
        <TextButton
            :primary="name !== undefined"
            :disabled="name === undefined"
            @click="handleSave"
        >
          保存する
        </TextButton>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/components/atoms/Dialog";
import FlexRow from "@/components/atoms/FlexRow";
import TextButton from "@/components/atoms/TextButton";
import TextField from "@/components/atoms/TextField";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import ApiMixin from "@/ApiMixin";
import ComponentMixin from "@/components/ComponentMixin";
import {mapGetters} from "vuex";

export default {
  mixins: [ApiMixin, ComponentMixin],
  name: "ApplicantSearchConditionsSaveDialog",
  components: {Label, FlexColumn, TextField, TextButton, FlexRow, Dialog},
  props: {
    open: {
      type: Boolean
    },
    andKeyword: {
      type: String
    },
    orKeyword: {
      type: String
    },
    data: {
      type: Array
    },
    dataType: {
      type: String
    },
    currentPrefectures: {
      type: Array,
    },
    prefectures: {
      type: Array,
    },
    positions: {
      type: Array
    },
    salaryLower: {
      type: Number,
    },
    salaryUpper: {
      type: Number,
    },
    gender: {
      type: Number
    },
    ageLower: {
      type: Number,
    },
    ageUpper: {
      type: Number,
    },
    medalist: {
      type: Boolean
    },
    newcomer: {
      type: Boolean
    },
    scoutable: {
      type: Boolean
    },
    id: {
      type: String
    },
    originalName: {
      type: String
    }
  },
  data() {
    return {
      name: undefined
    }
  },
  computed: {
    ...mapGetters("client", ["company"]),
    ...mapGetters("system", ["consts"]),
    dataLabel() {
      if (this.data && this.data.length > 0) {
        return this.data.map(item => this.constsToText(item, this.consts.dataGoodAt)).join("、")
      }
      return ""
    },
    currentPrefecturesLabel() {
      if (this.currentPrefectures && this.currentPrefectures.length > 0) {
        return this.currentPrefectures.map(item => this.constsToText(item, this.consts.preferredLocation)).join("、")
      }
      return ""
    },
    prefecturesLabel() {
      if (this.prefectures && this.prefectures.length > 0) {
        return this.prefectures.map(item => this.constsToText(item, this.consts.preferredLocation)).join("、")
      }
      return ""
    },
    positionsLabel() {
      if (this.positions && this.positions.length > 0) {
        return this.positions.map(item => this.constsToText(item, this.consts.currentJob)[0]).join("、")
      }
      return ""
    },
    genderLabel() {
      if (this.gender != null) {
        return this.constsToText(this.gender, this.consts.gender)
      }
      return ""
    }
  },
  methods: {
    async handleSave() {
      const conditions = {
        andKeyword: this.andKeyword,
        orKeyword: this.orKeyword,
        data: this.data,
        dataType: this.dataType,
        currentLocation: this.currentPrefectures,
        location: this.prefectures,
        currentJob: this.positions,
        ageLower: this.ageLower,
        ageUpper: this.ageUpper,
        medalist: this.medalist,
        newcomer: this.newcomer,
        scoutable: this.scoutable,
        salaryLower: this.salaryLower,
        salaryUpper: this.salaryUpper,
        gender: this.gender
      }
      if (this.id) {
        await this.updateChatRequestSearchConditions(this.company.id, this.id, this.name, conditions)
      } else {
        await this.saveChatRequestSearchConditions(this.company.id, this.name, conditions)
        this.name = undefined
      }
      this.$emit("close")
    }
  },
  watch: {
    originalName: {
      handler(value) {
        this.name = value
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>